import { GlobalCtasLPsExperiment } from '@mc/promos'
import { PageSource } from '@mc/track-event'

import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'

interface HeroCTAProps {
  fullWidth?: boolean
  outcomeName: string
}

export const HeroCTA = ({ fullWidth = false, outcomeName }: HeroCTAProps) => (
  <>
    <GlobalCtasLPsExperiment
      variant={(giftButton: React.ReactNode) => (
        <div className='d-flex flex-gap-3 mc-mb-3'>
          {giftButton}
          <CTA
            fullWidth
            trackProps={{
              category: outcomeName,
              content_type: 'product',
              location: 'hero',
              page_source: PageSource.OUTCOME,
            }}
          />
        </div>
      )}
    >
      <CTA
        fullWidth={fullWidth}
        className='mc-mb-3 mc-px-9'
        trackProps={{
          category: outcomeName,
          content_type: 'product',
          location: 'hero',
          page_source: PageSource.OUTCOME,
        }}
      />
    </GlobalCtasLPsExperiment>
    <p className={fullWidth ? 'mc-px-10 mc-text--center' : ''}>
      <PricingText
        translationKey='long'
        className={`mc-opacity--hinted mc-text-small ${fullWidth ? '' : 'mc-text--left'}`}
        useRevampedPricingCopy
      />
    </p>
  </>
)
